<template>
  <div class="behavior-select">
    <b-rate
      icon-pack="fas"
      size="is-small"
      v-model="behavior"
      @change="handleChanged"
    />
  </div>
</template>

<script>
export default {
  name: "BehaviorSelect",

  props: {
    initialBehavior: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      behavior: null,
    };
  },

  methods: {
    handleChanged(value) {
      this.$emit("onChanged", value);
    },
  },

  created() {
    this.behavior = this.initialBehavior;
  },
};
</script>

<style scoped></style>
